import React, { useEffect, useState, useRef } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import ArraySelect from '../Select/ArraySelect'
import { useObserver } from 'mobx-react'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { t } from 'i18next'

const StyledWrapper = styled.div`
  .form-group {
    padding-left: 20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`
const AliasTypeFilter = ({
  aliasTypeFilter,
  setAliasTypeFilter,
  showIsSearchable = true,
  defaultOptionIsSelectable = false,
}) => {
  const [aliasTypes, setAliasTypes] = useState([])
  let aliasTypeId = useObserver(() => aliasTypeFilter?.aliasTypeId || emptyGuid)
  const mountedRef = useRef(true)

  useEffect(() => {
    apiClient.getJson(APIEndpoints.aliasTypes).then((resp) => {
      if (!mountedRef.current) return null
      setAliasTypes(
        showIsSearchable ? resp.filter((item) => item.isSearchable) : resp
      )
      // setAliasTypes([])
    })
    return () => {
      mountedRef.current = false
    }
  }, [showIsSearchable])

  const updateAliasTypeFilter = (displayName, aliasTypeId = emptyGuid) => {
    let newObj = {
      displayName,
      aliasTypeId,
    }
    setAliasTypeFilter(newObj)
  }

  const handleChange = (e) => {
    let newAliasTypeId = e.target.value

    if (!isEmptyGuid(newAliasTypeId)) {
      const aliasTypeDisplayName = aliasTypes.find(
        (obj) => obj.id === newAliasTypeId
      ).displayName
      updateAliasTypeFilter(aliasTypeDisplayName, newAliasTypeId)
    } else {
      updateAliasTypeFilter(null)
    }
  }

  if (!aliasTypes || aliasTypes.length === 0) return null
  return (
    <StyledWrapper>
      <div>
        <Form.Group className='mb-3'>
          <Form.Label className='mb-1'>{t('orders:aliasFilter')}</Form.Label>
          <ArraySelect
            options={aliasTypes}
            value={aliasTypeId}
            onChange={handleChange}
            defaultOption={{ value: emptyGuid, name: ' ' }}
            defaultOptionIsSelectable={defaultOptionIsSelectable}
            returnEvent
          />
        </Form.Group>
      </div>
    </StyledWrapper>
  )
}

export default AliasTypeFilter
